import { include } from 'named-urls'

import { isProduction } from '@fourthwall/utils/dist/dev'

// NOTE: https://github.com/tricoder42/named-urls#using-an-include-route
// we use "self" to get paths of items using include function

const home = '/admin/dashboard'
const helpCenter = 'https://help.fourthwall.com'
const docs = 'https://docs.fourthwall.com'

export const getFourthwallUrl = () => {
  if (isProduction()) {
    return 'https://fourthwall.com'
  }

  return 'https://staging.fourthwall.com'
}

export const routing = {
  home,
  redirect: include(`${home}/redirect`, {
    googleAnalytics: 'google-analytics',
    meta: 'meta',
    streamlabs: 'streamlabs',
    twitch: 'twitch',
    youtube: 'youtube',
  }),
  connectIntegration: `${home}/connect-integration/:integration`,
  analytics: include(`${home}/analytics`, {
    self: '',
    overview: include('overview', {
      self: '',
      report: include(':reportType', {
        self: '',
      }),
      trackingPixels: 'tracking-pixels',
    }),
    reports: include('reports', {
      self: '',
    }),
    reportContributions: 'report/contributions', // redirect
    report: 'report/:reportType',
  }),
  analyticsV2: include(`${home}/analytics-v2`, {
    self: '',
    overview: include('overview', {
      self: '',
      trackingPixels: 'tracking-pixels',
    }),
    reports: include('reports', {
      self: '',
      report: include(':reportId', {
        self: '',
      }),
    }),
  }),
  apps: include(`${home}/apps`, {
    self: '',
    app: ':app',
    beehiiv: 'beehiiv',
    bookfunnel: 'bookfunnel',
    discord: 'discord',
    discordVerification: 'fwdiscord',
    echobrain: 'echobrain',
    instagram: 'instagram',
    instagramFeed: 'instagram-feed',
    klaviyo: 'klaviyo',
    kit: include('kit', {
      self: '',
      authorize: 'authorize',
    }),
    laylo: 'laylo',
    linktree: 'linktree',
    mailchimp: 'mailchimp',
    merchtrain: 'merchtrain',
    meta: 'meta',
    metaCAPI: 'meta-capi',
    packiyo: 'packiyo',
    redirect: include('redirect', {
      appConnect: ':app/connect',
    }),
    pledge: 'pledge',
    shipStation: 'ship-station',
    spotify: include('spotify', {
      self: '',
      podcast: include(':podcastId', {
        self: '',
      }),
    }),
    streamelements: 'streamelements',
    streamlabs: 'streamlabs',
    tiktok: 'tiktok',
    tiktokShop: 'tiktok-partner',
    twitch: 'twitch',
    twitchMembershipsDiscounts: 'twitch-discounts',
    twitchMembershipsDiscountsLegacy: 'twitchMembershipsDiscounts',
    twitterShops: 'twitter-shops',
    vimmi: 'vimmi',
    youTubeProductShelf: 'youtube-product-shelf',
    youTubeProductShelfLegacy: 'youtube-merch-shelf',
    zapier: 'zapier',
  }),
  onboarding: '/admin/creator-onboarding',
  products: include(`${home}/products`, {
    self: '*',
    all: include('all', {
      self: '',
      product: include(':productId', {
        self: '',
        variants: 'variants',
        gallery: 'gallery',
        sections: 'sections',
        settings: 'settings',
        costs: 'costs',
      }),
    }),
    combined: include('combined', {
      self: '',
      combinedId: include(':combinedId', {
        self: '',
      }),
    }),
    bundle: include('bundle', {
      self: '',
      bundleId: include(':bundleId', {
        self: '',
      }),
    }),
    giftCard: include('gift-card', {
      self: '',
      giftCardId: include(':giftCardId', {
        self: '',
      }),
    }),
    collections: include('collections', {
      self: '',
      create: include('create', { self: '' }),
      collection: include(':collectionId', { self: '' }),
    }),
    preview: ':productId/preview',
  }),
  productCatalog: {
    self: '/admin/products/',
    product: '/admin/products/:slug',
    favorites: '/admin/products/favorites',
  },
  productDesignerV3: include('/admin/v3/designer', {
    self: '',
    customizationEdit: ':customizationId/edit/offer/:productId',
  }),
  printfulEmbededDesigner: include('/admin/embedded/designer', {
    self: '',
    customizationEdit: ':customizationId/edit/offer/:productId',
  }),
  checkout: '/checkout/:checkoutId?/:stepId?',
  contributions: include(`${home}/contributions`, {
    self: '*',
    fulfillment: 'fulfillment',
    orders: include('orders', {
      all: '',
      order: include(':orderId', {
        self: '',
        edit: 'edit',
        cancel: 'cancel',
        refund: 'refund',
      }),
      donations: include('donations', {
        all: 'all',
        donation: include(':donationId', {
          self: '',
        }),
      }),
      giveaways: include('giveaways', {
        all: 'all',
        giveaway: ':giveawayId',
      }),
    }),
    thankYous: include('thankyous', {
      self: '',
    }),
  }),
  themeEditorV2: include(`${home}/store-design/`, {
    self: '',
    general: include('general', {
      self: '',
      fonts: 'fonts',
      fontChange: 'font-change',
      themes: 'themes',
    }),
    experimental: include('experimental', {
      self: '',
    }),
    layout: include('layout', {
      self: '',
      page: include(':pageId', {
        details: 'page-details',
        template: 'template-settings',
        collectionTemplate: 'collection-settings',
        self: '',
        sections: 'sections/:sectionKey',
        navigation: 'navigation/:navigationHandle',
      }),
    }),
    navigations: include('navigations', {
      self: '',
    }),
    themes: include('themes', {
      self: '',
    }),
    pages: include('pages', {
      self: '',
    }),
  }),
  promotions: include(`${home}/promotions`, {
    self: '*',
    giveawayPackages: include('giveaway-packages', {
      self: '',
      create: include('create', {
        self: '',
      }),
      giveawayPackage: include(':giveawayPackageId', {
        self: '',
      }),
    }),
    promotionCodes: include('promotion-codes', {
      self: '',
      create: include('create', {
        self: '',
      }),
      promotionCode: include(':promotionId', {
        self: '',
      }),
      membershipsPromotion: include('memberships/:promotionId', {
        self: '',
      }),
      membershipsPromotionCreate: include('memberships/create', {
        self: '',
      }),
    }),
    giftCards: include('gift-cards', {
      self: '',
      create: include('create', {
        self: '',
      }),
      giftCard: include(':giftCardId', {
        self: '',
      }),
    }),
  }),
  settings: include(`${home}/settings`, {
    self: '*',
    general: 'general',
    team: 'team',
    appsLegacy: include('apps', {
      app: ':app',
    }),
    shipping: include('shipping', {
      self: '',
      group: include('group', {
        self: ':shippingGroupId',
        create: 'create',
      }),
      inventoryShipments: include('inventory-shipments', {
        self: ':shippingId',
        create: 'create',
      }),
      inventoryStocks: include('inventory-stocks', {
        self: ':snapshotId',
      }),
    }),
    checkout: 'checkout',
    forDevelopers: 'for-developers',
    platformApps: include('platform-apps', {
      self: '',
      editApp: include(':appId', {
        self: '',
      }),
    }),
    domain: include('domain', {
      self: '',
      create: 'create',
      configuration: 'configuration',
    }),
    billing: include('billing', {
      self: '',
      transactions: 'transactions',
    }),
    plan: 'plan',
    samples: include('samples', {
      self: '',
      order: 'order',
    }),
    referrals: include('referrals', {
      self: '',
    }),
    thankYouCards: include('custom-inserts', {
      self: '',
    }),
  }),
  account: include(`${home}/account`, {
    self: '',
    security: 'security',
    emailNotifications: 'email-notifications',
    connectedSites: 'connected-sites',
  }),
  membershipsBeta: include(`${home}/memberships-beta`, {
    self: '',
  }),
  membershipsEnable: include(`${home}/memberships-enable`, {
    self: '',
  }),
  memberships: include(`${home}/memberships`, {
    self: '*',
    overview: 'overview',
    posts: include('posts', {
      self: '',
      create: 'create',
      post: include(':postId', {
        self: '',
      }),
      scheduled: include('scheduled', {
        all: 'all',
      }),
    }),
    series: include('series', {
      self: '',
      create: 'create',
      singleSeries: include(':singleSeriesId', {
        self: '',
      }),
    }),
    perks: include('perks', {
      self: '',
      create: 'create',
      tier: include(':tierId', {
        self: '',
      }),
    }),
    members: include('members', {
      self: '',
      member: include(':memberId', {
        self: '',
      }),
    }),
    messages: include('messages', {
      self: '',
      create: 'create',
      message: include(':messageId', {
        self: '',
      }),
    }),
    settings: include(`settings`, {
      self: '*',
      general: 'general',
      messages: 'messages',
      badges: include('badges', {
        self: '',
        create: 'create',
        badge: include(':badgeId', {
          self: '',
        }),
      }),
      customEmoji: 'custom-emoji',
      postTags: 'post-tags',
      rewardPoints: 'reward-points',
      welcomePost: 'welcome-posts',
      mobileApp: 'mobile-app',
      upselling: 'upselling',
    }),
  }),
  webview: include(`${home}/webview`, {
    recommendations: 'recommendations',
  }),
  internal: {
    customizeComingSoon: `${home}/store-design-v2/layout/password/`,
  },
  external: {
    hubspot: {
      bookACall: `https://meetings.hubspot.com/fourthwall/fourthwall-onboarding-session`,
    },
    helpCenter: {
      self: helpCenter,

      abandonedCheckoutEmails: `${helpCenter}/hc/en-us/articles/22988811094811`,
      beehiiv: `${helpCenter}/hc/en-us/articles/20819244391195`,
      buyNowPayLater: `${helpCenter}/hc/en-us/articles/22444724194715`,
      cookiePolicy: `${helpCenter}/hc/en-us/articles/22448093388443`,
      creditCard: `${helpCenter}/hc/en-us/articles/13331256450203`,
      giveawayLinks: `${helpCenter}/hc/en-us/articles/13331257130523`,
      googleTrackingPixels: `${helpCenter}/hc/en-us/articles/18176371774491`,
      hsCodes: `${helpCenter}/hc/en-us/articles/34812985219995`,
      kit: `${helpCenter}/hc/en-us/articles/33538824678299`,
      klaviyo: `${helpCenter}/hc/en-us/articles/19419091421339`,
      laylo: `${helpCenter}/hc/en-us/articles/18537710201115`,
      mailchimp: `${helpCenter}/hc/en-us/articles/33148497222939`,
      merchtrain: `${helpCenter}/hc/en-us/articles/39469007712027`,
      meta: `${helpCenter}/hc/en-us/articles/13331280410907`,
      metaCAPI: `${helpCenter}/hc/en-us/articles/37430330256539`,
      metaTrackingPixels: `${helpCenter}/hc/en-us/articles/13331225583771`,
      multicurrency: `${helpCenter}/hc/en-us/articles/18300828600347`,
      orderingSamples: `${helpCenter}/hc/en-us/articles/13331282778395`,
      challengeInfo: `${helpCenter}/hc/en-us/articles/13331282778395`,
      payouts: `${helpCenter}/hc/en-us/articles/38467054614299`,
      productCategory: `${helpCenter}/hc/en-us/articles/34812399812123`,
      selfFulfillment: `${helpCenter}/hc/en-us/articles/13331253379739`,
      selfSipping: `${helpCenter}/hc/en-us/articles/17385690128923`,
      shipStationIntegration: `${helpCenter}/hc/en-us/articles/18437332272411`,
      streamAlerts: `${helpCenter}/hc/en-us/articles/13331283282331`,
      subscriptionDomains: `${helpCenter}/hc/en-us/articles/39760033351579`,
      thankYous: `${helpCenter}/hc/en-us/articles/13331252782235`,
      tiktokShop: `${helpCenter}/hc/en-us/articles/20059966612763`,
      tiktokShopPayment: `${helpCenter}/hc/en-us/articles/19638911329819`,
      twitchGifting: `${helpCenter}/hc/en-us/articles/13331277761563`,
      twitchMembershipsIntegrations: `${helpCenter}/hc/en-us/articles/14314760750235`,
      twitchShopDiscounts: `${helpCenter}/hc/en-us/articles/24358709408411`,
      youtubeProductShelf: `${helpCenter}/hc/en-us/articles/13331252530203`,
      digitalFilesSizeLimits: `${helpCenter}/hc/en-us/articles/32739362055195`,
      zapier: `${helpCenter}/hc/en-us/articles/33148470973595`,
      giftCards: `${helpCenter}/hc/en-us/articles/43219449572123`,
    },
    signup: `${getFourthwallUrl()}/signup`,
    guides: `${getFourthwallUrl()}/guides`,
    termsOfService: `${getFourthwallUrl()}/terms-of-service`,
    privacyPolicy: `${getFourthwallUrl()}/privacy-policy`,
    docs: {
      self: docs,
      openAPI: `${docs}/open-api/`,
    },
    shipStation: {
      apiSettings: 'https://ship12.shipstation.com/settings/api',
      paymentSettings: 'https://ship12.shipstation.com/settings/payments',
    },
    klaviyo: {
      dashboard: 'https://www.klaviyo.com/dashboard',
    },
    beehiiv: {
      apiDocs:
        'https://developers.beehiiv.com/docs/v2/bktd9a7mxo67n-create-an-api-key?utm_source=fourthwall',
    },
    bookfunnel: {
      docs: 'https://authors.bookfunnel.com/help/setup-fourthwall/',
    },
    instagram: {
      accountSwitchDoc: 'https://help.instagram.com/2358103564437429',
    },
    laylo: {
      apiDocs: 'https://laylo.com/settings?tab=Integrations',
    },
    linktree: {
      createLink: 'https://linktr.ee/admin?action=create-link&linkType=fourthwall',
    },
    tiktok: {
      orderDetails: `https://seller-us.tiktok.com/order/detail`,
      warehouse: `https://seller-us.tiktok.com/profile/account-setting/warehouse`,
      shippingTemplate: `https://seller-us.tiktok.com/logistics/shipping-template`,
    },
    youtube: {
      shoppingSettings: 'https://studio.youtube.com/channel/user/monetization/shopping',
    },
    partnerDashboard: isProduction()
      ? 'https://partners.fourthwall.com/'
      : 'https://partners.staging.fourthwall.com/',
    packiyo: {
      connect: `/admin/platform-apps/apps.packiyo/connect?redirect_uri=${encodeURIComponent(isProduction() ? 'https://packiyo.fourthwall.app/oauth/fourthwall' : 'https://packiyo-staging.fourthwall.app/oauth/fourthwall')}`,
    },
    merchtrain: {
      connect: `/admin/platform-apps/apps.merchtrain/connect?redirect_uri=${encodeURIComponent(isProduction() ? 'https://apps.fourthwall.app/apps.merchtrain/oauth/fourthwall' : 'https://apps-staging.fourthwall.app/apps.merchtrain/oauth/fourthwall')}`,
    },
    echobrain: {
      connect: `/admin/platform-apps/apps.echobrain/connect?redirect_uri=${encodeURIComponent(isProduction() ? 'https://echo-brain.com/oauth' : 'https://reviews.bigsigmadevelopment.com/oauth')}`,
      learnMore: `https://echo-brain.com/blog/documentation/fourthwall-integration-quick-start-guide/`,
    },
    vimmi: {
      connect: `/admin/platform-apps/apps.vimmi/connect?redirect_uri=${encodeURIComponent(isProduction() ? 'https://s-console.vimmi.net/oauth2/install?source=fourthwall' : 'https://s-console.demo-shoprz.live/oauth2/install?source=fourthwall')}`,
      learnMore: `https://help.vimmi.net/en/articles/11008840-vimmi-app-quick-start-guide`,
      dashboard: isProduction()
        ? `https://s-console.vimmi.net/oauth2/run`
        : `https://s-console.demo-shoprz.live/oauth2/run`,
    },
    zapier: {
      createZap: `https://zapier.com/webintent/create-zap?create=true&entry-point-location=explore&entry-point-method=connect_call_to_action&steps%5B0%5D%5Bapp%5D=${encodeURIComponent(
        isProduction() ? 'App187064CLIAPI@1.2.4' : 'App186960CLIAPI@1.2.4',
      )}`,
    },
  },
  blockedTransactions: `${home}/blocked-transactions`,
}

export { reverse } from 'named-urls'
